<template>
  <div class="employee-permission-window">
    <div class="permission-header">
      <div class="permission-info">
        <span>员工：{{ employeeData.employeeName }}</span>
        <span style="margin-left: 20px;">权限统计：{{ getPermissionStats().selected }}/{{ getPermissionStats().total }}</span>
      </div>
    </div>
    <div class="permission-content">
      <el-table :data="permissionData" border style="width: 100%">
        <el-table-column prop="configReportCode" label="检测报告编号">
        </el-table-column>
        <el-table-column prop="configReportName" label="检测报告名称" width="200">
        </el-table-column>
        <el-table-column prop="employeeName" label="人员姓名" width="120">
        </el-table-column>
        <el-table-column label="批准" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.approvalSign" @change="() => handlePermissionChange(scope.row, 'approvalSign')"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="审核" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.auditSign" @change="() => handlePermissionChange(scope.row, 'auditSign')"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="校核" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checkSign" @change="() => handlePermissionChange(scope.row, 'checkSign')"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="检测" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.testSign" @change="() => handlePermissionChange(scope.row, 'testSign')"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="permission-footer">
      <el-button type="primary" @click="handleSubmit">提交</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { queryPermissionsByEmployee, batchSaveOrUpdateEmployeeSignPermission } from '@/api/contract/contract';
import { appjs } from "@/utiljs/apputil";

export default {
  name: 'EmployeePermissionWindow',
  props: {
    employeeData: {
      type: Object,
      default: () => ({})
    },
    closeWindow: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      permissionData: [],
      loading: false
    }
  },
  created () {
    this.loadPermissionData();
  },
  methods: {
    // 加载权限数据
    async loadPermissionData () {
      if (!this.employeeData.employeePid) {
        appjs.showErrorMsg('员工信息不完整');
        return;
      }

      this.loading = true;
      try {
        const response = await queryPermissionsByEmployee({
          employeePid: this.employeeData.employeePid
        });

        if (response.retCode && response.retCode !== "ok") {
          appjs.showErrorMsg(response.retMsg || '获取权限数据失败');
        } else {
          // 处理返回的数据，设置默认勾选状态
          const rawData = response.dataList || response.additionalData || [];

          // 确保数据是响应式的
          this.permissionData = rawData.map(item => {
            const newItem = { ...item };

            // 确保每个权限字段都存在，如果接口返回权限为true，默认勾选
            newItem.approvalSign = !!newItem.approvalSign;
            newItem.auditSign = !!newItem.auditSign;
            newItem.checkSign = !!newItem.checkSign;
            newItem.testSign = !!newItem.testSign;

            // 确保configReportPid字段存在，用于提交数据
            if (!newItem.configReportPid) {
              console.warn('报告数据缺少configReportPid:', newItem);
            }

            return newItem;
          });

          console.log('加载的权限数据:', this.permissionData);

          // 调试：检查第一个数据项的权限字段
          if (this.permissionData.length > 0) {
            const firstItem = this.permissionData[0];
            console.log('第一个数据项:', firstItem);
            console.log('权限字段值:', {
              approvalSign: firstItem.approvalSign,
              auditSign: firstItem.auditSign,
              checkSign: firstItem.checkSign,
              testSign: firstItem.testSign
            });
          }
        }
      } catch (error) {
        console.error('获取权限数据失败:', error);
        appjs.showErrorMsg('获取权限数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 权限变更处理
    handlePermissionChange (row, permissionType) {
      // 处理权限变更的逻辑
      console.log('权限变更:', row, permissionType, row[permissionType]);
      console.log('变更前的值:', row[permissionType]);
      console.log('当前行数据:', row);

      // 确保数据响应式更新
      this.$set(row, permissionType, row[permissionType]);

      console.log('变更后的值:', row[permissionType]);
    },

    // 提交权限配置
    async handleSubmit () {
      if (!this.permissionData.length) {
        appjs.showErrorMsg('没有可提交的权限数据');
        return;
      }

      // 验证数据完整性
      const invalidData = this.permissionData.filter(item => !item.configReportPid);
      if (invalidData.length > 0) {
        appjs.showErrorMsg('存在无效的报告数据，请刷新页面重试');
        console.error('无效的报告数据:', invalidData);
        return;
      }

      const submitData = [];

      // 遍历报告权限，构建提交数据
      this.permissionData.forEach((report, index) => {
        // 检查批准权限
        if (report.approvalSign) {
          submitData.push({
            employeePid: this.employeeData.employeePid,
            configReportPid: report.configReportPid,
            sginType: 'Approval'
          });
        }

        // 检查审核权限
        if (report.auditSign) {
          submitData.push({
            employeePid: this.employeeData.employeePid,
            configReportPid: report.configReportPid,
            sginType: 'Audit'
          });
        }

        // 检查校核权限
        if (report.checkSign) {
          submitData.push({
            employeePid: this.employeeData.employeePid,
            configReportPid: report.configReportPid,
            sginType: 'Check'
          });
        }

        // 检查检测权限
        if (report.testSign) {
          submitData.push({
            employeePid: this.employeeData.employeePid,
            configReportPid: report.configReportPid,
            sginType: 'Test'
          });
        }
      });

      // 如果没有选择任何权限，仍需要传递员工信息以清空权限
      if (submitData.length === 0) {
        submitData.push({
          employeePid: this.employeeData.employeePid
        });
      }

      // 显示提交确认信息
      const reportCount = new Set(submitData.map(item => item.configReportPid)).size;
      const permissionCount = submitData.length;

      console.log('准备提交的权限数据:', submitData);
      console.log(`涉及 ${reportCount} 个报告，共 ${permissionCount} 个权限`);

      this.loading = true;
      try {
        const response = await batchSaveOrUpdateEmployeeSignPermission(submitData);

        if (response.retCode && response.retCode !== "ok") {
          appjs.showErrorMsg(response.retMsg || '保存权限失败');
        } else {
          appjs.showSuccessMsg('权限配置保存成功');
          this.closeWindow('权限配置保存成功');
        }
      } catch (error) {
        console.error('保存权限失败:', error);
        appjs.showErrorMsg('保存权限失败');
      } finally {
        this.loading = false;
      }
    },

    // 取消操作
    handleCancel () {
      this.closeWindow();
    },

    // 重置表单
    resertForm () {
      this.permissionData = [];
      this.loadPermissionData();
    },

    // 重置单个权限
    resetPermission (row, permissionType) {
      this.$set(row, permissionType, false);
      this.handlePermissionChange(row, permissionType);
    },

    // 获取权限统计信息
    getPermissionStats () {
      if (!this.permissionData.length) return { total: 0, selected: 0 };

      let total = 0;
      let selected = 0;

      this.permissionData.forEach(report => {
        total += 4; // 4种权限类型
        if (report.approvalSign) selected++;
        if (report.auditSign) selected++;
        if (report.checkSign) selected++;
        if (report.testSign) selected++;
      });

      return { total, selected };
    }
  }
}
</script>

<style scoped>
.employee-permission-window {
  padding: 20px;
}

.permission-header {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.permission-info {
  font-size: 14px;
  color: #606266;
}

.permission-info span {
  font-weight: 500;
}

.permission-content {
  margin-bottom: 20px;
}

.permission-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.permission-footer .el-button {
  margin: 0 10px;
}
</style>
